var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

/**
 * Mapping of torrent pieces to their respective availability in the torrent swarm. Used
 * by the torrent manager for implementing the rarest piece first selection strategy.
 */
var RarityMap = /*#__PURE__*/function () {
  "use strict";

  function RarityMap(torrent) {
    var _this = this;

    _classCallCheck(this, RarityMap);

    this._torrent = torrent;
    this._numPieces = torrent.pieces.length;
    this._pieces = new Array(this._numPieces);

    this._onWire = function (wire) {
      _this.recalculate();

      _this._initWire(wire);
    };

    this._onWireHave = function (index) {
      _this._pieces[index] += 1;
    };

    this._onWireBitfield = function () {
      _this.recalculate();
    };

    this._torrent.wires.forEach(function (wire) {
      _this._initWire(wire);
    });

    this._torrent.on('wire', this._onWire);

    this.recalculate();
  }
  /**
   * Get the index of the rarest piece. Optionally, pass a filter function to exclude
   * certain pieces (for instance, those that we already have).
   *
   * @param {function} pieceFilterFunc
   * @return {number} index of rarest piece, or -1
   */


  _createClass(RarityMap, [{
    key: "getRarestPiece",
    value: function getRarestPiece(pieceFilterFunc) {
      var candidates = [];
      var min = Infinity;

      for (var i = 0; i < this._numPieces; ++i) {
        if (pieceFilterFunc && !pieceFilterFunc(i)) continue;
        var availability = this._pieces[i];

        if (availability === min) {
          candidates.push(i);
        } else if (availability < min) {
          candidates = [i];
          min = availability;
        }
      }

      if (candidates.length) {
        // if there are multiple pieces with the same availability, choose one randomly
        return candidates[Math.random() * candidates.length | 0];
      } else {
        return -1;
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this2 = this;

      this._torrent.removeListener('wire', this._onWire);

      this._torrent.wires.forEach(function (wire) {
        _this2._cleanupWireEvents(wire);
      });

      this._torrent = null;
      this._pieces = null;
      this._onWire = null;
      this._onWireHave = null;
      this._onWireBitfield = null;
    }
  }, {
    key: "_initWire",
    value: function _initWire(wire) {
      var _this3 = this;

      wire._onClose = function () {
        _this3._cleanupWireEvents(wire);

        for (var i = 0; i < _this3._numPieces; ++i) {
          _this3._pieces[i] -= wire.peerPieces.get(i);
        }
      };

      wire.on('have', this._onWireHave);
      wire.on('bitfield', this._onWireBitfield);
      wire.once('close', wire._onClose);
    }
    /**
     * Recalculates piece availability across all peers in the torrent.
     */

  }, {
    key: "recalculate",
    value: function recalculate() {
      this._pieces.fill(0);

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this._torrent.wires[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var wire = _step.value;

          for (var i = 0; i < this._numPieces; ++i) {
            this._pieces[i] += wire.peerPieces.get(i);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "_cleanupWireEvents",
    value: function _cleanupWireEvents(wire) {
      wire.removeListener('have', this._onWireHave);
      wire.removeListener('bitfield', this._onWireBitfield);
      if (wire._onClose) wire.removeListener('close', wire._onClose);
      wire._onClose = null;
    }
  }]);

  return RarityMap;
}();

module.exports = RarityMap;